import { render, staticRenderFns } from "./DownTriangleSvg.vue?vue&type=template&id=3be694a5"
import script from "./DownTriangleSvg.vue?vue&type=script&lang=js"
export * from "./DownTriangleSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports